// eslint-disable-next-line no-restricted-imports
import API from 'app/gamma/src/api';
// eslint-disable-next-line no-restricted-imports
import { OrganizationsResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { TEAM_FIELDS } from './fields';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
import { featureFlagClient } from '@trello/feature-flag-client';
import { client } from '@trello/graphql';
import {
  LoadTeamDocument,
  LoadTeamQuery,
  LoadTeamQueryVariables,
} from './LoadTeamQuery.generated';

export const LOAD_TEAM_REQUEST = Symbol('loaders/LOAD_TEAM_REQUEST');
export const LOAD_TEAM_SUCCESS = Symbol('loaders/LOAD_TEAM_SUCCESS');
export const LOAD_TEAM_ERROR = Symbol('loaders/LOAD_TEAM_ERROR');

export type LoadTeamRequestAction = Action<typeof LOAD_TEAM_REQUEST, string>;

export type LoadTeamSuccessAction = Action<
  typeof LOAD_TEAM_SUCCESS,
  OrganizationsResponse
>;

export type LoadTeamErrorAction = Action<typeof LOAD_TEAM_ERROR, Error>;

// Action creators
const loadTeamRequest = actionCreator<LoadTeamRequestAction>(LOAD_TEAM_REQUEST);
const loadTeamSuccess = actionCreator<LoadTeamSuccessAction>(LOAD_TEAM_SUCCESS);
const loadTeamError = actionCreator<LoadTeamErrorAction>(LOAD_TEAM_ERROR);

export const loadTeam = (teamName: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    try {
      dispatch(loadTeamRequest(teamName));

      let team: OrganizationsResponse;
      if (featureFlagClient.get('fep.use-graphql-for-team-loader', false)) {
        const { data, error } = await client.query<
          LoadTeamQuery,
          LoadTeamQueryVariables
        >({
          query: LoadTeamDocument,
          variables: {
            orgId: teamName,
          },
          context: {
            operationName: 'LoadTeam',
            document: LoadTeamDocument,
          },
        });

        if (error) {
          throw error;
        }

        team = data.organization as OrganizationsResponse;
      } else {
        team = await API.client.rest.get<OrganizationsResponse>(
          `organization/${teamName}`,
          {
            query: {
              fields: TEAM_FIELDS,
            },
            headers: { 'X-Trello-Operation-Name': 'loadTeam' },
          },
        );
      }

      dispatch(loadTeamSuccess(team));
    } catch (err) {
      dispatch(loadTeamError(err));
    }
  };
};
